import './SearchButton.moduleV2.scss';
import { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import useDebounce from '../../hooks/useDebounce';
import { analytics } from '../../services/analytics';
import { useStores } from '../../stores/useStores';
import { SearchIcon } from '../SVGIcons/SearchIcon';

const SearchButton = observer(({ className }: { className: string }) => {
  const { categoriesStore, gamesSearchStore } = useStores();
  const { gamesHeroHeight, headerHeight } = categoriesStore;
  const { isSearchInputOpenV2 } = gamesSearchStore;
  const [inputValue, setInputValue] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);

  const debouncedSearchTerm = useDebounce<string>(inputValue, 500);

  useEffect(() => {
    if (!inputValue) {
      gamesSearchStore.setSearchTerm('');
      return;
    }
    if (debouncedSearchTerm) {
      gamesSearchStore.setSearchTerm(debouncedSearchTerm);
    }
  }, [gamesSearchStore, debouncedSearchTerm, inputValue, headerHeight, gamesHeroHeight]);

  // Set the cursor position to the end of the input value
  const handleFocus = () => {
    const input = inputRef.current;
    if (input) {
      const len = input.value.length;
      input.setSelectionRange(len, len);
    }
  };

  const handleClick = () => {
    if (inputRef.current) {
      if (!isSearchInputOpenV2) {
        inputRef.current.focus();
        gamesSearchStore.openSearch();
      } else {
        inputRef.current.value = '';
        inputRef.current.blur();
        gamesSearchStore.closeSearch();
      }
      void analytics.sendEvent('game_search', {
        event_action: 'click',
      });
    }
  };

  return (
    <div>
      <div className={classNames(className, { active: isSearchInputOpenV2 })} style={{ position: 'relative' }}>
        <span className={'icon-wrapper'} onClick={handleClick}>
          <SearchIcon />
        </span>
        <input
          ref={inputRef}
          autoComplete="off"
          className={classNames({ active: isSearchInputOpenV2 })}
          data-testid="lobby-search-box"
          type="search"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onFocus={handleFocus}
        />
      </div>
    </div>
  );
});

export default SearchButton;
